import { Grid } from "@mui/material";
import { useEffect } from "react";
import getCbInstance from "../../helpers/chargebee-instance.helper";
import { LandlineFormData, LandlineSubscriberFormData } from "../../models/add-phone-number.model";
import { mapChargebeeEstimateInvoice, PaymentStatus } from "../../models/payment.model";
import { PhoneNumberStatus } from "../../models/phone-number.model";
import { PlanModel, PlanType, TierOccurrence } from "../../models/plans.model";
import { SignupLandingFormData } from "../../models/signup-model";
import { PlanHistoryModel, RechargeStatus } from "../../models/transaction-history.model";
import ChargebeeService from "../../services/chargebee.service";
import { UserService } from "../../services/UserService";
import { UtilityService } from "../../services/UtilityService";
import PaymentHostpageDetails from "./payment-hostpage-details.component";
import { useLocation, useNavigate } from "react-router-dom";

export interface IPaymentProps extends Partial<LandlineSubscriberFormData>, Partial<LandlineFormData>, Partial<SignupLandingFormData> {
    Plan?: PlanModel;
    Tenure?: string;
    PhoneNumberID?: string;
    SubscriptionID?: string;
    PhoneNumberToRecharge?: string;
    PhoneNumberStatus?: PhoneNumberStatus;
    IsTeamsApp: boolean;
    IsAddonRecharge?: boolean;
    HandleNext: (data: any) => void;
    IsRecharge?: boolean;
    IsMobileDevice?: boolean;
    IsSignUp?: boolean;
    CurrentPlanID?: string;
    PhonePlans?: PlanHistoryModel[];
    Addons?: {
        [ID: string]: number;
    }
    Stepdata?: any
}
const Payment = (props: IPaymentProps) => {
    let APICalled = false;
    const cbInstance = getCbInstance();
    const { state } = useLocation();
    const navigate = useNavigate();
    const location = useLocation();
    APICalled = false;
    const checkout = () => {
        try {
            cbInstance.openCheckout({
                hostedPage: async () => {
                    let plan = (state.Plan as PlanModel || props.Plan || props.Stepdata?.Plan);
                    var data = state.IsAddonRecharge ? getAddonData() : getData();
                    var promise = state.IsAddonRecharge ? ChargebeeService.addonRecharge(data, state.AddonOccurrence || props.Stepdata.AddonOccurrence === TierOccurrence.RECURRING) : ChargebeeService.createHostPage(data)

                    return promise.then((response) => {
                        (global as any).paymentID = response.data.hostpage.id;
                        APICalled = false;
                        return response.data.hostpage;
                    })
                },
                success: (hostedPageId: any) => {
                    cbInstance.closeAll();
                    (global as any).PaymentCompleted = true;
                    setTimeout(
                        () => {
                            props.HandleNext({
                                ...state,
                                paymentID: hostedPageId,
                                phoneNumberID: state.IsSignUp ? state.SignUpPhoneNumberID : state.PhoneNumberID || props.PhoneNumberID,
                                phoneNumber: state.IsRecharge ? state.PhoneNumberToRecharge || props.PhoneNumberToRecharge : state.PhoneNumber || props.PhoneNumber,
                                planID: state.Plan?.PlanID || props.Plan?.PlanID || props.Stepdata?.Plan?.PlanID,
                                Tenure: state.Tenure || props.Tenure || props.Stepdata?.Tenure,
                                state: PaymentStatus.AWAITING,
                                IsSignUp: state.IsSignUp,
                                SignUpPhoneNumberID: state.SignUpPhoneNumberID
                            })

                        }
                        , 100
                    );
                },
                error: (error: any) => {
                    cbInstance.closeAll();
                },
                close: (e: any) => {
                    props.HandleNext({
                        // paymentID: "",
                        paymentID: (global as any).paymentID,
                        phoneNumberID: state.IsSignUp ? state.SignUpPhoneNumberID : state.PhoneNumberID || props.PhoneNumberID,
                        phoneNumber: state.IsRecharge ? state.PhoneNumberToRecharge || props.PhoneNumberToRecharge : state.PhoneNumber || props.PhoneNumber,
                        planID: state.Plan?.PlanID || props.Plan?.PlanID || props.Stepdata?.Plan?.PlanID,
                        Tenure: state.Tenure || props.Tenure || props.Stepdata?.Tenure,
                        // state: PaymentStatus.FAILED,
                        state: PaymentStatus.AWAITING,
                        IsSignUp: state.IsSignUp,
                        SignUpPhoneNumberID: state.SignUpPhoneNumberID
                    })
                },
                step: (step: any) => {
                }
            });
        } catch (exception) {
            console.log("Catch Exception", exception);
        }
    }

    const getData = () => {
        let user = JSON.parse(localStorage.getItem("current-user")?.toString()!);

        return !state.IsSignUp && UserService.hasSysAdminRole()
            ? {
                "billing_address[first_name]": state.FirstName || props.FirstName || ""
                , "billing_address[last_name]": state.LastName || props.LastName || ""
                , "billing_address[company]": state.Organization?.Name || props.Organization?.Name || ""
                , "billing_address[line1]": state.HouseNumber || props.HouseNumber || state.Organization?.HouseNumber || props.Organization?.HouseNumber
                , "billing_address[line2]": state.Address || props.Address || state.Organization?.Address || props.Organization?.Address
                , "billing_address[state_code]": state.State || props.State
                , "billing_address[city]": state.City || props.City
                , "billing_address[zip]": state.ZipCode || props.ZipCode
                , "billing_address[country]": state.Country || props.Country
                , "billing_address[email]": state.Organization?.Email || props.Organization?.Email || ""
                , "subscription[cf_phone_number]": `${UtilityService.unmaskPhoneNumber(state.IsRecharge ? state.PhoneNumberToRecharge || props.PhoneNumberToRecharge : state.PhoneNumber || props.PhoneNumber)}`
                , "subscription[cf_phone_id]": `${state.PhoneNumberID || props.PhoneNumberID}`
                , "subscription[cf_is_sign_up]": false

                , "subscription_items[item_price_id][0]": `Pricing_${(state.Tenure || props.Tenure || props.Stepdata?.Tenure) + "_" + (state.Plan?.PlanID || props.Plan?.PlanID || props.Stepdata?.Plan?.PlanID)}`
                , "subscription_items[quantity][0]": 1

                , ...getSubsciptionItems(1)

                , "customer[id]": `${state.Organization?.ID || state.Organization?.ID}`
                , "customer[email]": state.Organization?.Email || props.Organization?.Email || ""
                , "customer[first_name]": ""
                , "customer[last_name]": ""
                , "customer[company]": state.Organization?.Name || props.Organization?.Name || ""
                , "customer[phone]": `${UtilityService.unmaskPhoneNumber(state.Organization?.MobileNumber || props.Organization?.MobileNumber || "")}`
                , "redirect_url": `${window.location.origin}/payment-status?phoneNumberID=${state.PhoneNumberID || props.PhoneNumberID}&OrganizationID=${state.Organization?.ID || state.Organization?.ID}&phoneNumber=${UtilityService.unmaskPhoneNumber(state.IsRecharge ? state.PhoneNumberToRecharge || props.PhoneNumberToRecharge : state.PhoneNumber || props.PhoneNumber)}&planID=${state.Plan?.PlanID || props.Plan?.PlanID || props.Stepdata?.Plan?.PlanID}&Tenure=${state.Tenure || props.Tenure || props.Stepdata?.Tenure}`
                , "cancel_url": `${window.location.origin}/payment-status?phoneNumberID=${state.PhoneNumberID || props.PhoneNumberID}}&OrganizationID=${state.Organization?.ID || state.Organization?.ID}&phoneNumber=${UtilityService.unmaskPhoneNumber(state.IsRecharge ? state.PhoneNumberToRecharge || props.PhoneNumberToRecharge : state.PhoneNumber || props.PhoneNumber)}&planID=${state.Plan?.PlanID || props.Plan?.PlanID || props.Stepdata?.Plan?.PlanID}&Tenure=${state.Tenure || props.Tenure || props.Stepdata?.Tenure}`
            }
            : {
                "billing_address[first_name]": state.IsSignUp ? state.FirstName : user.firstName
                , "billing_address[last_name]": state.IsSignUp ? state.LastName : user.lastName
                , "billing_address[company]": state.Organization?.Name || props.Organization?.Name || ""
                , "billing_address[line1]": state.HouseNumber || props.HouseNumber || state.Organization?.HouseNumber || props.Organization?.HouseNumber
                , "billing_address[line2]": state.Address || props.Address || state.Organization?.Address || props.Organization?.Address
                , "billing_address[state_code]": state.State || props.State
                , "billing_address[city]": state.City || props.City
                , "billing_address[zip]": state.ZipCode || props.ZipCode
                , "billing_address[country]": state.Country || props.Country
                , "billing_address[email]": state.IsSignUp ? state.VerifiedEmail : user.email || state.Organization?.Email || props.Organization?.Email
                , "subscription[cf_phone_number]": `${UtilityService.unmaskPhoneNumber(state.IsRecharge ? state.PhoneNumberToRecharge || props.PhoneNumberToRecharge : state.PhoneNumber || props.PhoneNumber)}`
                , "subscription[cf_phone_id]": `${state.IsSignUp ? state.SignUpPhoneNumberID : state.PhoneNumberID || props.PhoneNumberID}`
                , "subscription[cf_is_sign_up]": state.IsSignUp

                , "subscription_items[item_price_id][0]": `Pricing_${(state.Tenure || props.Tenure || props.Stepdata?.Tenure) + "_" + (state.Plan?.PlanID || props.Plan?.PlanID || props.Stepdata?.Plan?.PlanID)}`
                , "subscription_items[quantity][0]": 1

                , ...getSubsciptionItems(1)

                , "customer[id]": `${state.Organization?.ID || props.Organization?.ID}`
                , "customer[email]": state.IsSignUp ? state.VerifiedEmail : state.Organization?.Email || props.Organization?.Email
                , "customer[first_name]": state.IsSignUp ? state.FirstName : user.firstName
                , "customer[last_name]": state.IsSignUp ? state.LastName : user.lastName
                , "customer[company]": state.Organization?.Name || props.Organization?.Name || ""
                , "customer[phone]": `${UtilityService.unmaskPhoneNumber(state.IsSignUp ? state.MobileNumber || props.MobileNumber : state.Organization?.MobileNumber || props.Organization?.MobileNumber)}`
                , "customer[cf_t_user_id]": state.IsSignUp ? "" : JSON.parse(localStorage.getItem("current-user")?.toString()).id

            }
    }

    const getAddonData = () => {
        let user = JSON.parse(localStorage.getItem("current-user")?.toString()!); //todo to get contact admin
        let plan = (state.Plan as PlanModel || props.Plan || props.Stepdata?.Plan);

        if (plan?.Type === PlanType.TIER) {
            return null;
        }
        else {
            if (state.AddonOccurrence || props.Stepdata.AddonOccurrence === TierOccurrence.ONE_TIME) {
                return UserService.hasSysAdminRole()
                    ? {

                        "billing_address[first_name]": state.FirstName || props.FirstName || ""
                        , "billing_address[last_name]": state.LastName || props.LastName || ""
                        , "billing_address[company]": state.Organization?.Name || props.Organization?.Name || ""
                        , "billing_address[line1]": state.Organization?.HouseNumber || props.Organization?.HouseNumber
                        , "billing_address[line2]": state.Organization?.Address || props.Organization?.Address
                        , "billing_address[state_code]": state.State || props.State
                        , "billing_address[city]": state.City || props.City
                        , "billing_address[zip]": state.ZipCode || props.ZipCode
                        , "billing_address[country]": state.Country || props.Country
                        , "billing_address[email]": state.Organization?.Email || props.Organization?.Email


                        , ...getItemPrices()


                        , "customer[id]": `${state.Organization?.ID || props.Organization?.ID}`
                        , "customer[cf_phone_id]": state.PhoneNumberID || props.PhoneNumberID
                        , "customer[email]": state.Organization?.Email || props.Organization?.Email
                        , "customer[first_name]": ""
                        , "customer[last_name]": ""
                        , "customer[company]": state.Organization?.Name || props.Organization?.Name || ""

                        , "customer[phone]": `${UtilityService.unmaskPhoneNumber(state.Organization?.MobileNumber || props.Organization?.MobileNumber)}`
                        , "redirect_url": `${window.location.origin}/payment-status?phoneNumberID=${state.PhoneNumberID || props.PhoneNumberID}&OrganizationID=${state.Organization?.ID || state.Organization?.ID}&phoneNumber=${UtilityService.unmaskPhoneNumber(state.PhoneNumberToRecharge || props.PhoneNumberToRecharge)}&planID=${state.Plan?.PlanID || props.Plan?.PlanID || props.Stepdata?.Plan?.PlanID}&Tenure=${state.Tenure || props.Tenure || props.Stepdata?.Tenure}`
                        , "cancel_url": `${window.location.origin}/payment-status?phoneNumberID=${state.PhoneNumberID || props.PhoneNumberID}&OrganizationID=${state.Organization?.ID || state.Organization?.ID}&phoneNumber=${UtilityService.unmaskPhoneNumber(state.PhoneNumberToRecharge || props.PhoneNumberToRecharge)}&planID=${state.Plan?.PlanID || props.Plan?.PlanID || props.Stepdata?.Plan?.PlanID}&Tenure=${state.Tenure || props.Tenure || props.Stepdata?.Tenure}`
                    }
                    : {
                        "billing_address[first_name]": user.firstName
                        , "billing_address[last_name]": user.lastName
                        , "billing_address[company]": state.Organization?.Name || props.Organization?.Name || ""
                        , "billing_address[line1]": state.Organization?.HouseNumber || props.Organization?.HouseNumber
                        , "billing_address[line2]": state.Organization?.Address || props.Organization?.Address
                        , "billing_address[state_code]": state.State || props.State
                        , "billing_address[city]": state.City || props.City
                        , "billing_address[zip]": state.ZipCode || props.ZipCode
                        , "billing_address[country]": state.Country || props.Country
                        , "billing_address[email]": state.Organization?.Email || props.Organization?.Email

                        , ...getItemPrices()

                        , "customer[id]": `${state.Organization?.ID || state.Organization?.ID}`
                        , "customer[cf_phone_id]": state.PhoneNumberID || props.PhoneNumberID
                        , "customer[email]": state.Organization?.Email || props.Organization?.Email
                        , "customer[first_name]": user.firstName || ""
                        , "customer[last_name]": user.lastName || ""
                        , "customer[company]": state.Organization?.Name || props.Organization?.Name || ""
                        , "customer[phone]": `${UtilityService.unmaskPhoneNumber(state.Organization?.MobileNumber || props.Organization?.MobileNumber)}`
                        , "customer[cf_t_user_id]": JSON.parse(localStorage.getItem("current-user")?.toString()).id

                    }
            }
            else {

                return UserService.hasSysAdminRole()
                    ? {
                        "billing_address[first_name]": state.FirstName || props.FirstName || ""
                        , "billing_address[last_name]": state.LastName || props.LastName || ""
                        , "billing_address[company]": state.Organization?.Name || props.Organization?.Name || ""
                        , "billing_address[line1]": state.Organization?.HouseNumber || props.Organization?.HouseNumber
                        , "billing_address[line2]": state.Organization?.Address || props.Organization?.Address
                        , "billing_address[state_code]": state.State || props.State
                        , "billing_address[city]": state.City || props.City
                        , "billing_address[zip]": state.ZipCode || props.ZipCode
                        , "billing_address[country]": state.Country || props.Country
                        , "billing_address[email]": state.Organization?.Email || props.Organization?.Email
                        , "subscription[cf_phone_number]": `${UtilityService.unmaskPhoneNumber(state.PhoneNumberToRecharge || props.PhoneNumberToRecharge)}`
                        , "subscription[cf_phone_id]": `${state.PhoneNumberID || props.PhoneNumberID}`
                        , "subscription[cf_is_sign_up]": false
                        , "subscription[id]": state.SubscriptionID || props.SubscriptionID

                        , ...getSubsciptionItems(0)
                        , "customer[id]": `${state.Organization?.ID || state.Organization?.ID}`
                        , "customer[email]": state.Organization?.Email || props.Organization?.Email || ""
                        , "customer[first_name]": ""
                        , "customer[last_name]": ""
                        , "customer[phone]": `${UtilityService.unmaskPhoneNumber(state.Organization?.MobileNumber || props.Organization?.MobileNumber)}`
                        , "customer[company]": state.Organization?.Name || props.Organization?.Name || ""

                        , "redirect_url": `${window.location.origin}/payment-status?phoneNumberID=${state.PhoneNumberID || props.PhoneNumberID}&OrganizationID=${state.Organization?.ID || state.Organization?.ID}&phoneNumber=${UtilityService.unmaskPhoneNumber(state.PhoneNumberToRecharge || props.PhoneNumberToRecharge)}&planID=${state.Plan?.PlanID || props.Plan?.PlanID || props.Stepdata?.Plan?.PlanID}&Tenure=${state.Tenure || props.Tenure || props.Stepdata?.Tenure}`
                        , "cancel_url": `${window.location.origin}/payment-status?phoneNumberID=${state.PhoneNumberID || props.PhoneNumberID}&OrganizationID=${state.Organization?.ID || state.Organization?.ID}&phoneNumber=${UtilityService.unmaskPhoneNumber(state.PhoneNumberToRecharge || props.PhoneNumberToRecharge)}&planID=${state.Plan?.PlanID || props.Plan?.PlanID || props.Stepdata?.Plan?.PlanID}&Tenure=${state.Tenure || props.Tenure || props.Stepdata?.Tenure}`
                    }
                    : {
                        "billing_address[first_name]": user.firstName
                        , "billing_address[last_name]": user.lastName
                        , "billing_address[company]": state.Organization?.Name || props.Organization?.Name || ""
                        , "billing_address[line1]": state.Organization?.HouseNumber || props.Organization?.HouseNumber
                        , "billing_address[line2]": state.Organization?.Address || props.Organization?.Address
                        , "billing_address[state_code]": state.State || props.State
                        , "billing_address[city]": state.City || props.City
                        , "billing_address[zip]": state.ZipCode || props.ZipCode
                        , "billing_address[country]": state.Country || props.Country
                        , "billing_address[email]": user.email || state.Organization?.Email || props.Organization?.Email
                        , "subscription[cf_phone_number]": `${UtilityService.unmaskPhoneNumber(state.PhoneNumberToRecharge || props.PhoneNumberToRecharge)}`
                        , "subscription[cf_phone_id]": `${state.PhoneNumberID || props.PhoneNumberID}`
                        , "subscription[cf_is_sign_up]": false
                        , "subscription[id]": state.SubscriptionID || props.SubscriptionID

                        , ...getSubsciptionItems(0)

                        , "customer[id]": `${state.Organization?.ID || props.Organization?.ID}`
                        , "customer[email]": user.email || state.Organization?.Email || props.Organization?.Email
                        , "customer[first_name]": user.firstName || ""
                        , "customer[last_name]": user.lastName || ""
                        , "customer[company]": state.Organization?.Name || props.Organization?.Name || ""
                        , "customer[phone]": `${UtilityService.unmaskPhoneNumber(state.Organization?.MobileNumber || props.Organization?.MobileNumber)}`
                        , "customer[cf_t_user_id]": JSON.parse(localStorage.getItem("current-user")?.toString()).id

                        , "redirect_url": `${window.location.origin}/payment-status?phoneNumberID=${state.PhoneNumberID || props.PhoneNumberID}&phoneNumber=${UtilityService.unmaskPhoneNumber(state.PhoneNumberToRecharge || props.PhoneNumberToRecharge)}&planID=${state.Plan?.PlanID || props.Plan?.PlanID || props.Stepdata?.Plan?.PlanID}&Tenure=${state.Tenure || props.Tenure || props.Stepdata?.Tenure}`
                        , "cancel_url": `${window.location.origin}/payment-status?phoneNumberID=${state.PhoneNumberID || props.PhoneNumberID}&phoneNumber=${UtilityService.unmaskPhoneNumber(state.PhoneNumberToRecharge || props.PhoneNumberToRecharge)}&planID=${state.Plan?.PlanID || props.Plan?.PlanID || props.Stepdata?.Plan?.PlanID}&Tenure=${state.Tenure || props.Tenure || props.Stepdata?.Tenure}`
                    }
            }
        }
    }

    const getItemPrices = () => {
        let addons = state.Addons || props?.Addons || props.Stepdata?.Addons;
        let addonKeys = Object.keys(addons);
        let itemPrices: any = {};
        addonKeys.forEach((key, index) => {
            itemPrices[`item_prices[item_price_id][${index}]`] = `Pricing_${key}`;
            itemPrices[`item_prices[quantity][${index}]`] = addons[key];
        });

        return itemPrices;
    }

    const getSubsciptionItems = (baseIndex: number) => {
        let addons = state.Addons || props?.Addons || props.Stepdata?.Addons;
        let addonKeys = Object.keys(addons);
        let subscriptionItems: any = {};
        addonKeys.forEach((key, index) => {
            subscriptionItems[`subscription_items[item_price_id][${baseIndex + index}]`] = `Pricing_${key}`;
            subscriptionItems[`subscription_items[quantity][${baseIndex + index}]`] =
                getAddonExistingQuantity(key) +
                addons[key];
        });

        return subscriptionItems;
    }

    const getAddonExistingQuantity = (addonID: string) => {
        let selectedPlanOngoingCount = (state.PhonePlans || props.PhonePlans || []).filter((x: PlanHistoryModel) => (x.PlanID === addonID) && x.StatusType === RechargeStatus.ONGOING).length;
        return selectedPlanOngoingCount;
    }

    const getHostPage = () => {
        try {
            let plan = (state.Plan as PlanModel || props.Plan || props.Stepdata?.Plan);
            var data = state.IsAddonRecharge ? getAddonData() : getData();
            var promise = state.IsAddonRecharge ? ChargebeeService.addonRecharge(data, state.AddonOccurrence || props.Stepdata.AddonOccurrence === TierOccurrence.RECURRING) : ChargebeeService?.createHostPage(data)

            return promise.then((response) => {
                (global as any).paymentID = response.data.hostpage.id;
                APICalled = false;
                navigate(location.pathname, { state: { ...state, PaymentLink: response.data.hostpage.url, ...mapChargebeeEstimateInvoice(response.data.estimate, (state.IsAddonRecharge ? state.AddonOccurrence || props.Stepdata?.AddonOccurrence : plan.TierOccurrence) === TierOccurrence.ONE_TIME) } })
            });
        } catch (exception) {
            console.log("Catch Exception", exception);
        }
    }

    useEffect(() => {
        if (!(global as any).paymentID && !APICalled) {
            APICalled = true;

            if (!state.IsSignUp && UserService.hasSysAdminRole()) {
                getHostPage()
            }
            else {
                checkout()
            }
        }
    }, [])

    return <>
        {
            !state.IsSignUp && (UserService.hasSysAdminRole() ?
                <PaymentHostpageDetails LoadingDetails={!(global as any).paymentID} PaymentLink={(global as any).paymentID ? state.PaymentLink : ""} HandleNext={props.HandleNext} IsMobileDevice={props.IsMobileDevice} stepdata={props.Stepdata} /> :

                <Grid container className={`add-phone-number-paper-border paper-background h-v-50 m-auto br-2`}></Grid>)
        }
    </>
};

export default Payment;